module.exports = __webpack_public_path__ + "img/step-3.0765470e.jpg";